"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPUAddressCarrierInfoModalCms = void 0;
var PPUAddressCarrierInfoModalCms = /** @class */ (function () {
    function PPUAddressCarrierInfoModalCms() {
        this.ppuAddressTitleLabel = 'Place of primary use';
        this.ppuAddressAccountHolderTitleLabel = 'Account holder info';
        this.ppuAddressDeviceUseDescriptionLabel = 'Tell us where you\'ll use this device the most.';
        this.accountHolderDescrLabel = 'Enter your account details exactly as they appear on your current carrier\'s bill.';
        this.ppuAddressNutritionText = "Tell us where you'll use this device the most. <strong>The address you\n     give us will be used to calculate the taxes on your monthly service.</strong>";
    }
    return PPUAddressCarrierInfoModalCms;
}());
exports.PPUAddressCarrierInfoModalCms = PPUAddressCarrierInfoModalCms;
//# sourceMappingURL=PPUAddressCarrierInfoModal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/PPUAddressCarrierInfoModal/PPUAddressCarrierInfoModal.cms.js
// module id = 2000
// module chunks = 8